import { Component, ElementRef, QueryList, ViewChildren, Output, Input, EventEmitter } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DataService } from "src/app/services/data.service";
import * as XLSX from 'xlsx';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { VendorStock } from 'src/app/models/vendor/vendor-stock';
interface Image {
  name: string;
  objectURL: string;
}
@Component({
  selector: 'app-vendor-stock',
  templateUrl: './vendor-stock.component.html',
  styleUrls: ['./vendor-stock.component.scss']
})
export class VendorStockComponent {


  @Input() title: string;
  public isOpen: boolean = false;
  @Output() reload: EventEmitter<void> = new EventEmitter<void>();

  reloadPage() {
    this.reload.emit();
  }

  uploadedFiles: any[] = [];
  public excelData: any[];
  public isValidFile: boolean = false;


  @Output() uploadComplete = new EventEmitter<VendorStock[]>();

  @ViewChildren('buttonEl') buttonEl!: QueryList<ElementRef>;

  public excelDatas: any;
  constructor(
    private messageService: MessageService,
    private dataService: DataService,
    private http: HttpClient
  ) { }

  onUpload(event: any) { 
    const file = event.files[0];
    this.uploadedFiles.push(file)
    const reader = new FileReader();
    var filename = file.name

    reader.onload = (e: any) => {
      const data = new Uint8Array(reader.result as ArrayBuffer);
      try {

        const workbook = XLSX.read(data, { type: 'buffer' });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const sheetData: any[][] = XLSX.utils.sheet_to_json(worksheet, { header: 1 });


        // Validate headers
        const headers = sheetData[0]?.map((h: string) => h.toLowerCase().trim());
        if (headers[0] !== 'catalog number' || headers[1] !== 'quantity') {
          this.isValidFile = false;
       
          this.messageService.add({
            severity: 'error',
            summary: 'Invalid file format',
            detail: 'First column must be "Catalog Number" and second "Quantity".',
          });
          return;
        }

        this.excelData = sheetData;
        this.isValidFile = true;

      } catch (error) {
        console.error('Error reading file:', error);
        this.isValidFile = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Could not read Excel file.',
        });
      }
    };
    reader.readAsArrayBuffer(file);
  }

 
  getFileIcon(file: { name: string }): string {
    const ext = file.name.split('.').pop()?.toLowerCase();
    switch (ext) {
      case 'xls':
      case 'xlsx':
        return 'pi-file-excel';
      default:
        return 'pi-file'; // Or return '' to hide icon for unsupported types
    }
  }


  onSubmit() {
    if (!this.isValidFile || this.excelData.length === 0) {
      this.messageService.add({
        severity: 'error',
        summary: 'Invalid data',
        detail: 'Cannot submit without valid Excel data.',
      });
      return;
    }

    const jsonString = JSON.stringify(this.excelData);
    const blob = new Blob([jsonString], { type: 'application/json' });
    const fileData = new File([blob], 'data.json', { type: 'application/json' });

    this.dataService.uploadVendorStockFile(fileData).subscribe({
      next: (result: VendorStock[]) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Upload complete',
          detail: 'File data submitted successfully.',
        });

        // Send data to child
        this.uploadComplete.emit(result); // response is your VendorStock[] list
        this.uploadedFiles = [];
        this.excelData = [];
      },
      error: (err) => {
        console.error(err);
        this.messageService.add({
          severity: 'error',
          summary: 'Upload failed',
          detail: 'Error uploading the file.',
        });
      }
    });
  }



  onImageMouseOver(file: Image) {
    this.buttonEl.toArray().forEach(el => {
      el.nativeElement.id === file.name ? el.nativeElement.style.display = 'flex' : null;
    })
  }

  onImageMouseLeave(file: Image) {
    this.buttonEl.toArray().forEach(el => {
      el.nativeElement.id === file.name ? el.nativeElement.style.display = 'none' : null;
    })
  }

  removeImage(event: Event, file: any) {
    event.stopPropagation();
    this.uploadedFiles = this.uploadedFiles.filter(f => f !== file);
  }


}

